export const allSegments = ["Education",
    "Builders & Developers",
    "General",
    "Coaching",
    "NBFC",
    "Healthcare",
    "Ecom/Start-ups",
    "Other",
]
export const activeSegments = [
    `Education`,
    `Builders & Developers`,
    `Coaching`,
    `General`
]